import React, { useState, useEffect } from 'react';

function Admin({ user }) {
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState({});
  const [activeTab, setActiveTab] = useState('dashboard');
  const [modAction, setModAction] = useState({});
  const [modStatus, setModStatus] = useState({});
  const [boostRates, setBoostRates] = useState([]);
  const [newRate, setNewRate] = useState({ pi_amount: '', days: '', label: '' });
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketReply, setTicketReply] = useState('');
  const [ticketStatus, setTicketStatus] = useState('in_progress');
  const [backups, setBackups] = useState([]);
  const [backupMsg, setBackupMsg] = useState('');
  const [backupLoading, setBackupLoading] = useState(false);
  const [analytics, setAnalytics] = useState(null);
  const [analyticsPeriod, setAnalyticsPeriod] = useState('week');
  const token = localStorage.getItem('token');
  const [allUsers, setAllUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roleForm, setRoleForm] = useState({ role: 'user', can_moderate_posts: false, can_manage_users: false, can_manage_communities: false, can_manage_admins: false, can_change_settings: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.username === 'khalidxpert') {
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setModerator = async (username, action) => {
    setModAction(prev => ({ ...prev, [username]: true }));
    try {
      const res = await fetch(`/api/moderator/${username}/`, {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ action })
      });
      const data = await res.json();
      alert(data.message || data.error);
    } catch (err) { console.error(err); }
    setModAction(prev => ({ ...prev, [username]: false }));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const postsRes = await fetch('/api/posts/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const postsData = await postsRes.json();
      setPosts(postsData);

      const totalVotes = postsData.reduce((s, p) => s + p.total_votes, 0);
      const totalComments = postsData.reduce((s, p) => s + p.comments.length, 0);
      const totalPi = postsData.reduce((s, p) => s + parseFloat(p.pi_reward_pool || 0), 0);
      const uniqueUsers = [...new Set(postsData.map(p => p.author.username))];
      setUsers(uniqueUsers);
      setStats({ posts: postsData.length, votes: totalVotes, comments: totalComments, pi: totalPi.toFixed(2), writers: uniqueUsers.length });
    } catch (err) { console.error(err); }
    // Fetch boost rates
    try {
      const ratesRes = await fetch('/api/boost/rates/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const ratesData = await ratesRes.json();
      setBoostRates(ratesData);
    } catch (err) { console.error(err); }
    try {
      const tRes = await fetch('/api/support/admin/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      setTickets(await tRes.json());
    } catch (err) { console.error(err); }
    try {
      const bRes = await fetch('/api/admin/backup/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const bData = await bRes.json();
      setBackups(bData.backups || []);
    } catch (err) { console.error(err); }
    try {
      const aRes = await fetch(`/api/admin/analytics/?period=week`, {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      setAnalytics(await aRes.json());
    } catch (err) { console.error(err); }
    try {
      const uRes = await fetch('/api/admin/users/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      setAllUsers(await uRes.json());
    } catch (err) { console.error(err); }
    try {
      const rRes = await fetch('/api/roles/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      setRoles(await rRes.json());
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const replyTicket = async () => {
    if (!selectedTicket) return;
    try {
      const res = await fetch('/api/support/admin/', {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedTicket.id, status: ticketStatus, reply: ticketReply })
      });
      const data = await res.json();
      alert(data.message || data.error);
      setSelectedTicket(null);
      setTicketReply('');
      fetchData();
    } catch (err) { console.error(err); }
  };

  const addBoostRate = async () => {
    if (!newRate.pi_amount || !newRate.days || !newRate.label) { alert('Fill all fields!'); return; }
    try {
      const res = await fetch('/api/boost/rates/', {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(newRate)
      });
      const data = await res.json();
      alert(data.message || data.error);
      setNewRate({ pi_amount: '', days: '', label: '' });
      fetchData();
    } catch (err) { console.error(err); }
  };

  const deleteBoostRate = async (id) => {
    if (!window.confirm('Delete this rate?')) return;
    try {
      await fetch('/api/boost/rates/', {
        method: 'DELETE',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      fetchData();
    } catch (err) { console.error(err); }
  };

  const deletePost = async (postId) => {
    if (!window.confirm('Delete this post?')) return;
    try {
      await fetch(`/api/posts/${postId}/delete/`, {
        method: 'DELETE',
        headers: { 'Authorization': `Token ${user.token}` }
      });
      fetchData();
    } catch (err) { console.error(err); }
  };

  if (!user || user.username !== 'khalidxpert') {
    return (
      <div style={styles.denied}>
        <h2>🚫 Access Denied</h2>
        <p>This page is only for PenFlow Admin.</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>⚙️ PenFlow Admin Panel</h1>
        <span style={styles.badge}>👑 khalidxpert</span>
      </div>

      {/* Tabs */}
      <div style={styles.tabs}>
        {['dashboard', 'posts', 'writers', 'moderators', 'boost', 'tickets', 'videos', 'merchants', 'pricing', 'payments', 'backup', 'analytics', 'roles'].map(tab => (
          <button
            key={tab}
            style={{ ...styles.tab, ...(activeTab === tab ? styles.tabActive : {}) }}
            onClick={() => setActiveTab(tab)}
          >
            {tab === 'dashboard' ? '📊 Dashboard' : tab === 'posts' ? '📝 Posts' : tab === 'writers' ? '👥 Writers' : tab === 'moderators' ? '🛡️ Moderators' : tab === 'boost' ? '🚀 Boost' : tab === 'tickets' ? '🎫 Tickets' : tab === 'backup' ? '💾 Backup' : tab === 'analytics' ? '📈 Analytics' : tab === 'videos' ? '🎬 Videos' : tab === 'merchants' ? '🏪 Merchants' : tab === 'pricing' ? 'Pricing' : tab === 'payments' ? 'Payments' : '👑 Roles'}
          </button>
        ))}
      </div>

      {loading ? <div style={styles.loading}>Loading...</div> : (
        <>
          {activeTab === 'dashboard' && (
            <div style={styles.statsGrid}>
              <div style={styles.statCard}><div style={styles.statNum}>{stats.posts}</div><div style={styles.statLabel}>Total Posts</div></div>
              <div style={styles.statCard}><div style={styles.statNum}>{stats.writers}</div><div style={styles.statLabel}>Writers</div></div>
              <div style={styles.statCard}><div style={styles.statNum}>{stats.votes}</div><div style={styles.statLabel}>Total Votes</div></div>
              <div style={styles.statCard}><div style={styles.statNum}>{stats.comments}</div><div style={styles.statLabel}>Comments</div></div>
              <div style={styles.statCard}><div style={styles.statNum}>{stats.pi} π</div><div style={styles.statLabel}>Pi Distributed</div></div>
            </div>
          )}

          {activeTab === 'posts' && (
            <div style={styles.list}>
              {posts.map(post => (
                <div key={post.id} style={styles.row}>
                  <div style={styles.rowInfo}>
                    <a href={`/post/${post.id}`} style={styles.postTitle}>{post.title}</a>
                    <span style={styles.rowMeta}>by {post.author.username} · 👍 {post.total_votes} · 💬 {post.comments.length}</span>
                  </div>
                  <button onClick={() => deletePost(post.id)} style={styles.deleteBtn}>🗑️ Delete</button>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'writers' && (
            <div style={styles.list}>
              <div style={{ marginBottom: '10px', color: '#999', fontSize: '12px' }}>Total: {allUsers.length} users</div>
              {allUsers.map((w, i) => (
                <div key={w.username} style={styles.row}>
                  <div style={styles.rowInfo}>
                    <span style={styles.postTitle}>#{i+1} @{w.username} {w.is_moderator ? '🛡️' : ''}</span>
                    <span style={styles.rowMeta}>{w.post_count} posts · Joined {w.date_joined}</span>
                  </div>
                  <a href={`/profile/${w.username}`} style={styles.hireBtn}>View</a>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'moderators' && (
            <div style={styles.list}>
              <div style={{ backgroundColor: '#f3e5f5', padding: '12px', borderRadius: '10px', color: '#6200ea', fontSize: '13px', marginBottom: '10px' }}>
                🛡️ Hire or fire moderators. Moderators can delete posts and comments.
              </div>
              {users.filter(u => u !== 'khalidxpert').map(username => (
                <div key={username} style={styles.row}>
                  <div style={styles.rowInfo}>
                    <a href={`/profile/${username}`} style={styles.postTitle}>👤 {username}</a>
                    <span style={styles.rowMeta}>{posts.filter(p => p.author.username === username).length} posts</span>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => setModerator(username, 'hire')} disabled={modAction[username]}
                      style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '15px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
                      Hire
                    </button>
                    <button onClick={() => setModerator(username, 'fire')} disabled={modAction[username]}
                      style={{ backgroundColor: '#ff4444', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '15px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
                      Fire
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          {activeTab === 'boost' && (
            <div style={styles.list}>
              <div style={styles.modInfo}>🚀 Set boost rates for sponsored posts.</div>
              <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <h3 style={{ color: '#6200ea', marginBottom: '12px', fontSize: '15px' }}>Add New Rate</h3>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <input style={{ padding: '8px', borderRadius: '8px', border: '2px solid #e0e0e0', flex: 1, minWidth: '80px' }} placeholder="Pi Amount" type="number" value={newRate.pi_amount} onChange={e => setNewRate({...newRate, pi_amount: e.target.value})} />
                  <input style={{ padding: '8px', borderRadius: '8px', border: '2px solid #e0e0e0', flex: 1, minWidth: '80px' }} placeholder="Days" type="number" value={newRate.days} onChange={e => setNewRate({...newRate, days: e.target.value})} />
                  <input style={{ padding: '8px', borderRadius: '8px', border: '2px solid #e0e0e0', flex: 2, minWidth: '120px' }} placeholder="Label (e.g. Basic - 1 Day)" value={newRate.label} onChange={e => setNewRate({...newRate, label: e.target.value})} />
                  <button style={styles.hireBtn} onClick={addBoostRate}>Add</button>
                </div>
              </div>
              {boostRates.map(rate => (
                <div key={rate.id} style={styles.row}>
                  <div style={styles.rowInfo}>
                    <span style={styles.postTitle}>{rate.label}</span>
                    <span style={styles.rowMeta}>{rate.pi_amount} Pi = {rate.days} days</span>
                  </div>
                  <button onClick={() => deleteBoostRate(rate.id)} style={styles.deleteBtn}>🗑️ Delete</button>
                </div>
              ))}
            </div>
          )}
          {activeTab === 'videos' && (
            <VideoAdminTab token={token || localStorage.getItem('token')} />
          )}

          {activeTab === 'merchants' && (
          <MerchantAdminTab token={localStorage.getItem('token')} />
        )}
        {activeTab === 'pricing' && <PricingAdminTab token={localStorage.getItem('token')} />}
        {activeTab === 'payments' && <PaymentFixTab token={localStorage.getItem('token')} />}
        {activeTab === 'backup' && (
            <div>
              {backupMsg && <div style={{ backgroundColor: '#d1fae5', color: '#065f46', padding: '10px', borderRadius: '8px', marginBottom: '12px', fontWeight: 'bold' }}>{backupMsg}</div>}
              <button style={{ ...styles.hireBtn, marginBottom: '16px', width: '100%', padding: '14px', fontSize: '15px' }}
                disabled={backupLoading}
                onClick={async () => {
                  setBackupLoading(true);
                  setBackupMsg('');
                  try {
                    const res = await fetch('/api/admin/backup/', {
                      method: 'POST',
                      headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
                      body: JSON.stringify({ action: 'backup' })
                    });
                    const data = await res.json();
                    setBackupMsg(data.message || data.error);
                    fetchData();
                  } catch(e) { setBackupMsg('Error creating backup'); }
                  setBackupLoading(false);
                }}>
                {backupLoading ? '⏳ Creating backup...' : '💾 Create New Backup'}
              </button>
              <h3 style={{ color: '#6200ea', marginBottom: '10px' }}>📂 Available Backups</h3>
              {backups.length === 0 ? <div style={styles.modInfo}>No backups found</div> :
                backups.map((b, i) => (
                  <div key={i} style={{ ...styles.row, flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>📦 {b.name}</div>
                        <div style={{ color: '#999', fontSize: '12px' }}>Size: {b.size}</div>
                      </div>
                      <button style={{ ...styles.hireBtn, backgroundColor: '#0d9488', fontSize: '12px', padding: '6px 12px' }}
                        onClick={async () => {
                          if (!window.confirm(`Restore from ${b.name}? This will overwrite current data!`)) return;
                          const res = await fetch('/api/admin/backup/', {
                            method: 'POST',
                            headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
                            body: JSON.stringify({ action: 'restore', filename: b.name })
                          });
                          const data = await res.json();
                          setBackupMsg(data.message || data.error);
                        }}>
                        🔄 Restore
                      </button>
                    </div>
                  </div>
                ))
              }
            </div>
          )}

          {activeTab === 'tickets' && (
            <div style={styles.list}>
              {selectedTicket ? (
                <div>
                  <button style={{ ...styles.hireBtn, marginBottom: '12px' }} onClick={() => setSelectedTicket(null)}>← Back</button>
                  <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                    <h3 style={{ color: '#6200ea' }}>{selectedTicket.title}</h3>
                    <p style={{ color: '#999', fontSize: '12px' }}>@{selectedTicket.username} · {selectedTicket.created_at}</p>
                    <p style={{ color: '#333' }}>{selectedTicket.body}</p>
                    <select style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #e0e0e0', marginBottom: '10px' }}
                      value={ticketStatus} onChange={e => setTicketStatus(e.target.value)}>
                      <option value="open">Open</option>
                      <option value="in_progress">In Progress</option>
                      <option value="resolved">Resolved</option>
                      <option value="closed">Closed</option>
                    </select>
                    <textarea style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #e0e0e0', marginBottom: '10px', boxSizing: 'border-box', fontFamily: 'inherit' }}
                      placeholder="Your reply..." rows={4} value={ticketReply} onChange={e => setTicketReply(e.target.value)} />
                    <button style={styles.hireBtn} onClick={replyTicket}>✅ Send Reply</button>
                  </div>
                </div>
              ) : (
                tickets.length === 0 ? <div style={styles.modInfo}>No tickets yet</div> :
                tickets.map(t => (
                  <div key={t.id} style={styles.row} onClick={() => { setSelectedTicket(t); setTicketReply(t.admin_reply || ''); setTicketStatus(t.status); }}>
                    <div style={styles.rowInfo}>
                      <span style={styles.postTitle}>{t.title}</span>
                      <span style={styles.rowMeta}>@{t.username} · {t.category} · {t.created_at}</span>
                    </div>
                    <span style={{ backgroundColor: t.status==='open'?'#0d9488':t.status==='resolved'?'#10b981':'#3b82f6', color:'white', padding:'4px 10px', borderRadius:'10px', fontSize:'11px', fontWeight:'bold' }}>
                      {t.status.replace('_',' ')}
                    </span>
                  </div>
                ))
              )}
            </div>
          )}
          {activeTab === 'analytics' && (
            <div>
              {/* Period selector */}
              <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
                {['today', 'week', 'month', 'year'].map(p => (
                  <button key={p} style={{ ...styles.hireBtn, backgroundColor: analyticsPeriod === p ? '#6200ea' : '#f3e5f5', color: analyticsPeriod === p ? 'white' : '#6200ea' }}
                    onClick={async () => {
                      setAnalyticsPeriod(p);
                      const res = await fetch(`/api/admin/analytics/?period=${p}`, {
                        headers: { 'Authorization': `Token ${user.token}` }
                      });
                      setAnalytics(await res.json());
                    }}>
                    {p === 'today' ? '📅 Today' : p === 'week' ? '📆 Week' : p === 'month' ? '🗓️ Month' : '📊 Year'}
                  </button>
                ))}
              </div>

              {analytics && (
                <div>
                  {/* Summary cards */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '16px' }}>
                    {[
                      { label: '👥 New Users', value: analytics.summary.new_users, sub: `Total: ${analytics.summary.total_users}`, tab: 'writers' },
                      { label: '📝 New Posts', value: analytics.summary.new_posts, sub: `Total: ${analytics.summary.total_posts}`, tab: 'posts' },
                      { label: '💰 Pi Earned', value: `${analytics.summary.total_pi} π`, sub: `${analytics.summary.payment_count} payments`, tab: null },
                      { label: '💬 Messages', value: analytics.summary.new_messages, sub: `🤝 ${analytics.summary.new_connections} connections`, tab: null },
                    ].map((s, i) => (
                      <div key={i} onClick={() => s.tab && setActiveTab(s.tab)}
                        style={{ backgroundColor: 'white', borderRadius: '12px', padding: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', textAlign: 'center', cursor: s.tab ? 'pointer' : 'default', border: s.tab ? '2px solid #f3e5f5' : '2px solid transparent' }}>
                        <div style={{ color: '#999', fontSize: '12px', marginBottom: '4px' }}>{s.label}</div>
                        <div style={{ color: '#6200ea', fontWeight: 'bold', fontSize: '22px' }}>{s.value}</div>
                        <div style={{ color: '#bbb', fontSize: '11px', marginTop: '2px' }}>{s.sub}</div>
                        {s.tab && <div style={{ color: '#6200ea', fontSize: '10px', marginTop: '4px' }}>Tap to view →</div>}
                      </div>
                    ))}
                  </div>

                  {/* Daily chart */}
                  <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '14px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                    <h3 style={{ color: '#6200ea', margin: '0 0 12px', fontSize: '14px' }}>📊 Last 7 Days Activity</h3>
                    {analytics.daily.map((d, i) => (
                      <div key={i} style={{ marginBottom: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '3px' }}>
                          <span style={{ color: '#666', fontWeight: 'bold' }}>{d.date}</span>
                          <span style={{ color: '#999' }}>📝{d.posts} 👤{d.users} 💰{d.payments}</span>
                        </div>
                        <div style={{ backgroundColor: '#f0f0f0', borderRadius: '4px', height: '6px' }}>
                          <div style={{ backgroundColor: '#6200ea', borderRadius: '4px', height: '6px', width: `${Math.min((d.posts + d.users + d.payments) * 10, 100)}%` }} />
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Top posters */}
                  {analytics.top_posters.length > 0 && (
                    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '14px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                      <h3 style={{ color: '#6200ea', margin: '0 0 10px', fontSize: '14px' }}>✍️ Top Writers</h3>
                      {analytics.top_posters.map((p, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                          <span style={{ color: '#333', fontSize: '13px' }}>#{i+1} @{p.author__username}</span>
                          <span style={{ color: '#6200ea', fontWeight: 'bold', fontSize: '13px' }}>{p.count} posts</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Top earners */}
                  {analytics.top_earners.length > 0 && (
                    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                      <h3 style={{ color: '#6200ea', margin: '0 0 10px', fontSize: '14px' }}>💰 Top Earners</h3>
                      {analytics.top_earners.map((p, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                          <span style={{ color: '#333', fontSize: '13px' }}>#{i+1} @{p.post__author__username || 'N/A'}</span>
                          <span style={{ color: '#0d9488', fontWeight: 'bold', fontSize: '13px' }}>{parseFloat(p.total).toFixed(2)} π</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {activeTab === 'roles' && (
            <div>
              <h3 style={{ color: '#6200ea', marginBottom: '12px' }}>👑 Role Management</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {roles.filter(r => r.username !== 'khalidxpert' && r.username !== 'admin').map(r => (
                  <div key={r.username} style={{ backgroundColor: 'white', borderRadius: '12px', padding: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {r.avatar && <img src={r.avatar} alt={r.username} style={{ width: '30px', height: '30px', borderRadius: '50%' }} />}
                        <span style={{ fontWeight: 'bold', color: '#333' }}>@{r.username}</span>
                        <span style={{ backgroundColor: r.role === 'admin' ? '#6200ea' : r.role === 'moderator' ? '#0d9488' : '#eee', color: r.role === 'user' ? '#666' : 'white', fontSize: '10px', padding: '2px 8px', borderRadius: '8px' }}>{r.role}</span>
                      </div>
                      <button onClick={() => { setSelectedUser(r.username); setRoleForm({ role: r.role, can_moderate_posts: r.can_moderate_posts, can_manage_users: r.can_manage_users, can_manage_communities: r.can_manage_communities, can_manage_admins: r.can_manage_admins, can_change_settings: r.can_change_settings }); }}
                        style={{ backgroundColor: '#6200ea', color: 'white', border: 'none', padding: '4px 12px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>
                        Edit
                      </button>
                    </div>
                    {selectedUser === r.username && (
                      <div style={{ backgroundColor: '#f3e5f5', borderRadius: '10px', padding: '12px', marginTop: '8px' }}>
                        <div style={{ marginBottom: '8px' }}>
                          <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#6200ea' }}>Role:</label>
                          <select value={roleForm.role} onChange={e => setRoleForm({...roleForm, role: e.target.value})}
                            style={{ marginLeft: '8px', padding: '4px 8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '12px' }}>
                            <option value="user">👤 User</option>
                            <option value="moderator">🛡️ Moderator</option>
                            <option value="admin">⚙️ Admin</option>
                          </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
                          {[
                            { key: 'can_moderate_posts', label: '📝 Moderate Posts' },
                            { key: 'can_manage_users', label: '👥 Manage Users' },
                            { key: 'can_manage_communities', label: '🌐 Manage Communities' },
                            { key: 'can_manage_admins', label: '⚙️ Manage Admins' },
                            { key: 'can_change_settings', label: '🔧 Change Settings' },
                          ].map(p => (
                            <label key={p.key} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', cursor: 'pointer' }}>
                              <input type="checkbox" checked={roleForm[p.key]} onChange={e => setRoleForm({...roleForm, [p.key]: e.target.checked})} />
                              {p.label}
                            </label>
                          ))}
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={async () => {
                            await fetch(`/api/roles/${selectedUser}/`, {
                              method: 'POST', headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
                              body: JSON.stringify(roleForm)
                            });
                            setSelectedUser(null);
                            const rRes = await fetch('/api/roles/', { headers: { 'Authorization': `Token ${user.token}` } });
                            setRoles(await rRes.json());
                            alert('Role updated!');
                          }} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>
                            ✓ Save
                          </button>
                          <button onClick={() => setSelectedUser(null)} style={{ backgroundColor: '#ef4444', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const styles = {
  container: { maxWidth: '900px', margin: '20px auto', padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#6200ea', margin: 0 },
  badge: { backgroundColor: '#34d399', padding: '6px 14px', borderRadius: '20px', fontWeight: 'bold', fontSize: '14px' },
  tabs: { display: 'flex', gap: '6px', marginBottom: '16px', flexWrap: 'wrap' },
  tab: { padding: '8px 14px', borderRadius: '20px', border: '2px solid #6200ea', backgroundColor: 'white', color: '#6200ea', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' },
  tabActive: { backgroundColor: '#6200ea', color: 'white' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px' },
  statCard: { backgroundColor: 'white', borderRadius: '12px', padding: '20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  statNum: { fontSize: '28px', fontWeight: 'bold', color: '#6200ea' },
  statLabel: { fontSize: '13px', color: '#666', marginTop: '5px' },
  list: { display: 'flex', flexDirection: 'column', gap: '10px' },
  row: { backgroundColor: 'white', borderRadius: '10px', padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.08)' },
  rowInfo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  postTitle: { color: '#6200ea', fontWeight: 'bold', textDecoration: 'none', fontSize: '15px' },
  rowMeta: { color: '#999', fontSize: '12px' },
  deleteBtn: { backgroundColor: '#ff4444', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '15px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' },
  denied: { textAlign: 'center', padding: '80px 20px', color: '#666' },
  loading: { textAlign: 'center', padding: '40px', color: '#999' },
};


function VideoAdminTab({ token }) {
  const [videos, setVideos] = React.useState([]);
  const [applications, setApplications] = React.useState([]);
  const [activeSection, setActiveSection] = React.useState('applications');

  React.useEffect(() => {
    fetch('/api/videos/', {
      headers: { Authorization: `Token ${token}` }
    }).then(r => r.json()).then(setVideos).catch(console.error);
    fetch('/api/videos/admin/applications/', {
      headers: { Authorization: `Token ${token}` }
    }).then(r => r.json()).then(data => setApplications(data.applications || [])).catch(console.error);
  }, [token]);

  const handleApprove = async (id) => {
    await fetch(`/api/videos/admin/applications/${id}/approve/`, {
      method: 'POST', headers: { Authorization: `Token ${token}` }
    });
    setApplications(prev => prev.map(a => a.id === id ? {...a, status: 'approved'} : a));
  };

  const handleReject = async (id) => {
    await fetch(`/api/videos/admin/applications/${id}/reject/`, {
      method: 'POST', headers: { Authorization: `Token ${token}` }
    });
    setApplications(prev => prev.map(a => a.id === id ? {...a, status: 'rejected'} : a));
  };

  const handleDeleteVideo = async (id) => {
    if (!window.confirm('Delete this video?')) return;
    await fetch(`/api/videos/admin/delete/${id}/`, {
      method: 'DELETE', headers: { Authorization: `Token ${token}` }
    });
    setVideos(prev => prev.filter(v => v.id !== id));
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button onClick={() => setActiveSection('applications')}
          style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: activeSection === 'applications' ? '#6200ea' : '#eee', color: activeSection === 'applications' ? '#fff' : '#000', cursor: 'pointer', fontWeight: 'bold' }}>
          Channel Applications ({applications.filter(a => a.status === 'pending').length} pending)
        </button>
        <button onClick={() => setActiveSection('videos')}
          style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: activeSection === 'videos' ? '#6200ea' : '#eee', color: activeSection === 'videos' ? '#fff' : '#000', cursor: 'pointer', fontWeight: 'bold' }}>
          All Videos ({videos.length})
        </button>
      </div>

      {activeSection === 'applications' && (
        <div>
          {applications.length === 0 ? <p style={{ color: '#aaa' }}>No applications yet</p> : applications.map(app => (
            <div key={app.id} style={{ background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '8px', padding: '16px', marginBottom: '12px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '15px' }}>{app.channel_name}</div>
              <div style={{ color: '#666', fontSize: '13px' }}>@{app.username} • {app.category}</div>
              {app.description && <div style={{ color: '#444', fontSize: '13px', marginTop: '6px' }}>{app.description}</div>}
              <div style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}>{app.created_at}</div>
              <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                {app.status === 'pending' ? (
                  <>
                    <button onClick={() => handleApprove(app.id)} style={{ background: '#4caf50', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold' }}>Approve</button>
                    <button onClick={() => handleReject(app.id)} style={{ background: '#f44336', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold' }}>Reject</button>
                  </>
                ) : (
                  <span style={{ padding: '6px 12px', borderRadius: '8px', background: app.status === 'approved' ? '#e8f5e9' : '#ffebee', color: app.status === 'approved' ? '#2e7d32' : '#c62828', fontWeight: 'bold' }}>
                    {app.status === 'approved' ? 'Approved' : 'Rejected'}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {activeSection === 'videos' && (
        <div>
          {videos.length === 0 ? <p style={{ color: '#aaa' }}>No videos yet</p> : videos.map(v => (
            <div key={v.id} style={{ background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '8px', padding: '12px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontWeight: 'bold' }}>{v.title}</div>
                <div style={{ color: '#666', fontSize: '13px' }}>@{v.uploader} • {v.views_count} views</div>
              </div>
              <button onClick={() => handleDeleteVideo(v.id)} style={{ background: '#f44336', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontWeight: 'bold' }}>Delete</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Admin;
// placeholder

function MerchantAdminTab({ token }) {
  const [merchants, setMerchants] = React.useState([]);
  const [status, setStatus] = React.useState('pending');
  const [loading, setLoading] = React.useState(true);
  const [msg, setMsg] = React.useState('');
  const BACKEND = '/api';

  React.useEffect(() => { fetchMerchants(); }, [status]);

  const fetchMerchants = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BACKEND}/merchants/admin/list/?status=${status}`, {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d = await r.json();
      setMerchants(d.merchants || []);
    } catch(e) {}
    setLoading(false);
  };

  const doAction = async (id, action) => {
    try {
      const r = await fetch(`${BACKEND}/merchants/admin/action/${id}/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
        body: JSON.stringify({ action })
      });
      const d = await r.json();
      if (d.success) { setMsg('✅ ' + d.message); fetchMerchants(); }
    } catch(e) { setMsg('❌ Error'); }
  };

  return (
    <div>
      <h3 style={{ color: '#0F6E56', marginBottom: 16 }}>🏪 Merchant Applications</h3>
      {msg && <div style={{ background: '#0d2a1a', border: '1px solid #22c55e', borderRadius: 8, padding: 10, marginBottom: 12, color: '#22c55e' }}>{msg}</div>}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['pending', 'approved', 'rejected'].map(s => (
          <button key={s} onClick={() => setStatus(s)}
            style={{ padding: '6px 16px', background: status === s ? '#0F6E56' : '#1a1a2e', color: status === s ? '#000' : '#aaa', border: '1px solid #2a2a4a', borderRadius: 6, cursor: 'pointer', textTransform: 'capitalize' }}>
            {s === 'pending' ? '⏳' : s === 'approved' ? '✅' : '❌'} {s} ({status === s ? merchants.length : '?'})
          </button>
        ))}
      </div>
      {loading ? <p style={{ color: '#aaa' }}>Loading...</p> :
       merchants.length === 0 ? <p style={{ color: '#aaa' }}>No {status} merchants</p> :
       merchants.map(m => (
        <div key={m.id} style={{ background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 10, padding: 14, marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
            <div>
              <p style={{ margin: 0, fontWeight: 'bold', color: '#fff' }}>{m.business_name}</p>
              <p style={{ margin: '4px 0 0', color: '#aaa', fontSize: 13 }}>@{m.user} | 🥧 @{m.pi_username} | 📍 {m.city}, {m.country} | 🕐 {m.created_at}</p>
              {m.description && <p style={{ margin: '4px 0 0', color: '#aaa', fontSize: 12 }}>{m.description.substring(0, 80)}...</p>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {status === 'pending' && <>
                <button onClick={() => doAction(m.id, 'approve')} style={{ padding: '6px 14px', background: '#22c55e', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>✅ Approve</button>
                <button onClick={() => doAction(m.id, 'reject')} style={{ padding: '6px 14px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>❌ Reject</button>
              </>}
              {status === 'approved' && !m.is_verified && (
                <button onClick={() => doAction(m.id, 'verify')} style={{ padding: '6px 14px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>✓ Verify</button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function PaymentFixTab({ token }) {
  const [paymentId, setPaymentId] = React.useState('');
  const [txid, setTxid] = React.useState('');
  const [result, setResult] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const BACKEND = '/api';

  const fixPayment = async (action) => {
    if (!paymentId) { setResult('Payment ID required!'); return; }
    setLoading(true);
    setResult('');
    try {
      const r = await fetch(BACKEND + '/payments/fix/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
        body: JSON.stringify({ payment_id: paymentId, txid: txid, action })
      });
      const d = await r.json();
      setResult(JSON.stringify(d, null, 2));
    } catch(e) { setResult('Error: ' + e.message); }
    setLoading(false);
  };

  const checkPayment = async () => {
    if (!paymentId) { setResult('Payment ID required!'); return; }
    setLoading(true);
    try {
      const r = await fetch(BACKEND + '/payments/check/' + paymentId + '/', {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d = await r.json();
      setResult(JSON.stringify(d, null, 2));
    } catch(e) { setResult('Error: ' + e.message); }
    setLoading(false);
  };

  const inp = { width: '100%', padding: '10px', background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box', marginBottom: 10 };
  const btn = { padding: '10px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold', fontSize: 13 };

  return (
    <div>
      <h3 style={{ color: '#0F6E56', marginBottom: 16 }}>Payment Fix Utility</h3>
      <p style={{ color: '#aaa', fontSize: 13, marginBottom: 16 }}>Use this to fix stuck or pending Pi payments</p>
      
      <div style={{ background: '#0d1b2a', borderRadius: 10, padding: 16, marginBottom: 16 }}>
        <label style={{ color: '#aaa', fontSize: 12, display: 'block', marginBottom: 4 }}>Payment ID *</label>
        <input value={paymentId} onChange={e => setPaymentId(e.target.value)} placeholder="e.g. SMA6iMyliCN8BSNRioCDvT7UIGL1" style={inp} />
        <label style={{ color: '#aaa', fontSize: 12, display: 'block', marginBottom: 4 }}>TxID (optional - auto-detected)</label>
        <input value={txid} onChange={e => setTxid(e.target.value)} placeholder="e.g. 81d0b8de875f..." style={inp} />
        
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button onClick={checkPayment} disabled={loading} style={{ ...btn, background: '#3b82f6', color: '#fff' }}>
            Check Status
          </button>
          <button onClick={() => fixPayment('complete')} disabled={loading} style={{ ...btn, background: '#22c55e', color: '#000' }}>
            Complete Payment
          </button>
          <button onClick={() => { if(window.confirm('Warning: user_to_app payments cannot be cancelled by developer. Only complete them. Continue?')) fixPayment('cancel'); }} disabled={loading} style={{ ...btn, background: '#ef4444', color: '#fff' }}>
            Cancel Payment
          </button>
        </div>
      </div>

      {loading && <p style={{ color: '#0F6E56' }}>Processing...</p>}
      {result && (
        <div style={{ background: '#0d1b2a', borderRadius: 8, padding: 12 }}>
          <pre style={{ color: '#22c55e', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0 }}>{result}</pre>
        </div>
      )}
    </div>
  );
}

function PricingAdminTab({ token }) {
  const [plans, setPlans] = React.useState([]);
  const [msg, setMsg] = React.useState('');
  const BACKEND = '/api';

  React.useEffect(() => { fetchPlans(); }, []);

  const fetchPlans = async () => {
    const r = await fetch(BACKEND + '/merchants/pricing/');
    const d = await r.json();
    setPlans(d.plans || []);
  };

  const savePlan = async (plan) => {
    const r = await fetch(BACKEND + '/merchants/admin/update-pricing/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
      body: JSON.stringify(plan)
    });
    const d = await r.json();
    if (d.success) setMsg('Saved!');
    else setMsg('Error: ' + d.error);
  };

  const inp = { padding: '6px 10px', background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 6, color: '#fff', fontSize: 13, width: 80 };

  return (
    <div>
      <h3 style={{ color: '#0F6E56', marginBottom: 16 }}>Merchant Pricing Control</h3>
      {msg && <p style={{ color: '#22c55e', marginBottom: 12 }}>{msg}</p>}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #2a2a4a' }}>
              {['Plan', 'Price (Pi/mo)', 'Max Products', 'Boost Price', 'Boost Days', 'Action'].map(h => (
                <th key={h} style={{ padding: '8px 12px', color: '#aaa', textAlign: 'left' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {plans.map((p, i) => (
              <tr key={p.plan} style={{ borderBottom: '1px solid #2a2a4a' }}>
                <td style={{ padding: '10px 12px', color: '#0F6E56', fontWeight: 'bold', textTransform: 'capitalize' }}>{p.plan}</td>
                <td style={{ padding: '10px 12px' }}>
                  <input type="number" defaultValue={p.price_pi} style={inp}
                    onChange={e => plans[i].price_pi = parseFloat(e.target.value)} />
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <input type="number" defaultValue={p.max_products} style={inp}
                    onChange={e => plans[i].max_products = parseInt(e.target.value)} />
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <input type="number" defaultValue={p.boost_price_pi} style={{...inp, width: 70}}
                    onChange={e => plans[i].boost_price_pi = parseFloat(e.target.value)} />
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <input type="number" defaultValue={p.boost_days} style={{...inp, width: 60}}
                    onChange={e => plans[i].boost_days = parseInt(e.target.value)} />
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <button onClick={() => savePlan(plans[i])}
                    style={{ padding: '5px 12px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: 12 }}>
                    Save
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
